export default __webpack_public_path__ + "static/media/petter.970e6355.mp4";